import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";
import { FC } from "react";

export const BoxIconSvg = () => (
  <svg
    width="41"
    height="43"
    viewBox="0 0 41 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M38.8137 9.66173L21.97 0.445515C21.52 0.196844 21.0142 0.0664062 20.5 0.0664062C19.9858 0.0664062 19.48 0.196844 19.03 0.445515L2.18625 9.66555C1.70522 9.92875 1.30368 10.3163 1.02356 10.7876C0.74343 11.259 0.594995 11.7969 0.59375 12.3452V30.6513C0.594995 31.1997 0.74343 31.7376 1.02356 32.209C1.30368 32.6803 1.70522 33.0678 2.18625 33.331L19.03 42.5511C19.48 42.7997 19.9858 42.9302 20.5 42.9302C21.0142 42.9302 21.52 42.7997 21.97 42.5511L38.8137 33.331C39.2948 33.0678 39.6963 32.6803 39.9764 32.209C40.2566 31.7376 40.405 31.1997 40.4062 30.6513V12.3472C40.406 11.7979 40.2581 11.2587 39.9779 10.7863C39.6977 10.3138 39.2956 9.92539 38.8137 9.66173ZM20.5 3.1252L35.8795 11.5471L30.1794 14.6651L14.7999 6.24321L20.5 3.1252ZM20.5 19.969L5.12051 11.5471L11.6111 7.99266L26.9906 16.4145L20.5 19.969ZM37.3438 30.659L22.0312 39.0407V22.6161L28.1562 19.2646V26.094C28.1562 26.5001 28.3176 26.8895 28.6047 27.1767C28.8919 27.4639 29.2814 27.6252 29.6875 27.6252C30.0936 27.6252 30.4831 27.4639 30.7703 27.1767C31.0574 26.8895 31.2188 26.5001 31.2188 26.094V17.5879L37.3438 14.2363V30.6513V30.659Z"
      fill="#525354"
    />
  </svg>
);

export const BoxIcon: FC<Partial<CustomIconComponentProps>> = (props) => (
  <Icon component={BoxIconSvg} {...props} />
);

export default BoxIcon;

BoxIcon.displayName = "BoxIcon";
